import { map, tap } from 'rxjs';

import { Injectable } from '@angular/core';

import { AuthStore } from '@/app/core/store/auth';
import { HttpService } from '@/app/core/services/http';
import { Profile } from '@/app/api/profile/profile.types';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(
    private http: HttpService,
    private authStore: AuthStore,
  ) {}

  getProfileInfo() {
    return this.http.get<{ user: Profile }>('profile').pipe(
      map((profileInfo) => profileInfo.user),
      tap((user) => this.authStore.setAuthUser(user)),
    );
  }
}
